import * as React from "react";

import * as S from "@styled";

import AssistantModal, { PromptType } from "./Modals/AssistantModal";
import useAzureAiStatus, { AzureAiStatus } from "shared/hooks/useAzureAiStatus";
import { styled } from "styled-components";

import {
    buttonBackgroundAndBorderColorDisabled,
    buttonColorDisabled,
} from "shared/styledComponents/button/Button";

const AssistantModalLauncher: React.FC<AssistantModalLauncherProps> = (
    props
) => {
    const azureAiStatus = useAzureAiStatus();
    const [showAssistantModal, setShowAssistantModal] = React.useState(false);

    const handleOpenAssistantButtonClick = () => {
        if (azureAiStatus === AzureAiStatus.Enabled) {
            setShowAssistantModal(true);
        }
    };

    if (!azureAiStatus || azureAiStatus === AzureAiStatus.Disabled) {
        return null;
    }

    const quotaExceeded = azureAiStatus === AzureAiStatus.QuotaExceeded;

    return (
        <>
            <StyledAiButton
                onClick={handleOpenAssistantButtonClick}
                disabled={quotaExceeded}
                title={quotaExceeded ? "Quota exceeded" : undefined}
            >
                Frends assistant
            </StyledAiButton>

            {showAssistantModal && !quotaExceeded && (
                <AssistantModal
                    elementId={props.elementId}
                    type={props.type}
                    show={showAssistantModal}
                    onClose={() => setShowAssistantModal(false)}
                />
            )}
        </>
    );
};

const StyledAiButton = styled(S.Button)`
  position: relative;
  border: 0px !important;

  --clr-1: #6717ff;
  --clr-2: #aa8dfa;
  --clr-3: #d9ccfd;
  background-color: ${S.Colors.purpleBackground} !important;
  color: ${S.Colors.purplePrimary} !important;

  @property --gradient-angle {
    syntax: "<angle>";
    initial-value: 90deg;
    inherits: false;
  }

  @keyframes rotate {
    0% {
      --gradient-angle: 0deg;
    }
    100% {
      --gradient-angle: 360deg;
    }
  }
  &:hover {
    color: ${S.Colors.purplePrimary} !important;
    background-color: ${S.Colors.purpleTertiary} !important;
  }
  &:disabled {
    &:before,
    &:after {
      background: unset !important;
    }
    color: ${buttonColorDisabled} !important;
    background-color: ${buttonBackgroundAndBorderColorDisabled} !important;
  }
  &:after,
  &:before {
    content: " ";
    position: absolute;
    z-index: -1;
    inset: -2px;
    background: conic-gradient(
      from var(--gradient-angle),
      var(--clr-1),
      var(--clr-2),
      var(--clr-3),
      var(--clr-2),
      var(--clr-1)
    );
    border-radius: 15px;
    animation: rotate 3s linear infinite;
  }

  &:after {
    filter: blur(6px);
  }
`;

interface AssistantModalLauncherProps {
    elementId: string;
    type: PromptType;
}

export default AssistantModalLauncher;
